import React from "react";
import { Card } from "primereact/card";
import SignupDialog from "./SignupDialog";

const SignupPage = () => {
  return (
    <div className="flex">
      <div className="w-6 p-image relative">
        <img
          src="/signup-cropped.png"
          alt="image"
          width={0}
          height={0}
          sizes="100vw"
          style={{ width: "100%", height: "100%" }}
        ></img>
      </div>
      <div className="w-6">
        <Card className="h-screen">
          <SignupDialog />
        </Card>
      </div>
    </div>
  );
};

export default SignupPage;
